
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/vip",
      function () {
        return require("private-next-pages/visitor/vip/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/vip"])
      });
    }
  